import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import type { EmailsProps, EmailsRef } from './Emails.data';
import styles from './Emails.module.scss';
import Heading from '../../atoms/heading/Heading';
import Text from '../../atoms/text/Text';
import useThemeScrollBlock from '../../../hooks/useThemeScrollBlock';

export default function Emails({
  className,
  blok,
  ref,
}: EmailsProps & { ref?: Ref<EmailsRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  useThemeScrollBlock(elementRef, blok.use_accent_color);

  return (
    <div ref={elementRef} className={classNames(styles.emails, className)} {...sbEditable(blok)}>
      {blok.emails.map((email) => (
        <div className={styles.emailContainer} key={email._uid}>
          <Heading
            as="h4"
            size="heading-04"
            disableTriggerInOnScroll={false}
            className={styles.title}
          >
            {email.title}
          </Heading>
          <Text as="p" size="body-large" disableTriggerInOnScroll={false}>
            <a href={`mailto:${email?.email_link?.email || email?.email_link?.url}`}>
              {email?.email_address}
            </a>
          </Text>
        </div>
      ))}
    </div>
  );
}
